import { CarouselVideo, OriginalVideo, VideoAutoplay, VideoWithPlayButton } from "../components/VideoVariants/HomeVideoVariants";
import * as React from "react";

interface Variation {
  id: string;
  component: JSX.Element;
}

export type VariationsConfig = {
  control: Variation;
  [key: string]: Variation;
};

type ConvertExperiment = {
  experimentId: string;
  goalId: string;
  variations: VariationsConfig;
};

const isProduction =
  typeof window !== "undefined" &&
  !(
    window.location.hostname.includes(".g.shorthand.com") ||
    window.location.hostname.includes("staging.shorthand.com") ||
    window.location.hostname.includes("test.shorthand.com")
  );

export const HOME_VIDEO_EXPERIMENT: ConvertExperiment = {
  experimentId: isProduction ? "1004161720" : "1004158796",
  goalId: isProduction ? "100448156" : "100448149",
  variations: {
    control: {
      id: isProduction ? "1004382317" : "1004374971",
      component: <OriginalVideo />,
    },
    playButton: {
      id: isProduction ? "1004382318" : "1004374972",
      component: <VideoWithPlayButton />,
    },
    autoplay: {
      id: isProduction ? "1004382319" : "1004374973",
      component: <VideoAutoplay />,
    },
  },
};

export const HOMEPAGE_CAROUSEL_EXPERIMENT: ConvertExperiment = {
  experimentId: isProduction ? "1004171113" : "1004171114",
  goalId: isProduction ? "100448156" : "100448149",
  variations: {
    control: {
      id: isProduction ? "1004403938" : "1004403940",
      component: <OriginalVideo />,
    },
    carouselVideo: {
      id: isProduction ? "1004403939" : "1004403941",
      component: <CarouselVideo />,
    },
  },
};
